import UrlCodes from "./urlCodes";

export default {
    assessment: `/${UrlCodes.assessments}/:uuid`,
    assessmentKey: `/${UrlCodes.assessments}/keys/:key`,
    dashboard: '/',
};
